import React from 'react';
import { Check, Gift } from 'lucide-react';
export function ValueBreakdown() {
  return <section className="w-full py-16 md:py-24 bg-[#F5F1E8]" data-id="element-489">
      <div className="max-w-4xl mx-auto px-6 md:px-12" data-id="element-490">
        <h2 className="text-4xl md:text-5xl text-[#3E2723] mb-12 text-center" data-id="element-491">
          Everything You Get Today
        </h2>

        <div className="bg-white rounded-2xl shadow-xl overflow-hidden border border-[#3E2723]/10" data-id="element-492">
          <div className="bg-[#3E2723] text-white p-6 text-center" data-id="element-493">
            <h3 className="text-2xl font-bold" data-id="element-494">The Resort Secrets Bundle</h3>
          </div>

          <div className="p-6 md:p-8 space-y-4" data-id="element-495">
            <div className="flex items-center justify-between py-3 border-b border-[#3E2723]/10" data-id="element-496">
              <div className="flex items-center gap-3" data-id="element-497">
                <Check className="w-5 h-5 text-[#14B8A6]" data-id="element-498" />
                <span className="text-lg text-[#3E2723] font-medium" data-id="element-499">
                  The 20-Page Resort Secrets Playbook
                </span>
              </div>
              <span className="text-lg text-[#3E2723]/60 line-through" data-id="element-500">
                $49.00
              </span>
            </div>

            <div className="flex items-center justify-between py-3 border-b border-[#3E2723]/10" data-id="element-501">
              <div className="flex items-center gap-3" data-id="element-502">
                <Check className="w-5 h-5 text-[#14B8A6]" data-id="element-503" />
                <span className="text-lg text-[#3E2723] font-medium" data-id="element-504">
                  12 Masterclass Recipes (Oaxaca/Baja/Riviera Maya)
                </span>
              </div>
              <span className="text-lg text-[#14B8A6] font-bold" data-id="element-505">Included</span>
            </div>

            <div className="flex items-center justify-between py-3 border-b border-[#3E2723]/10" data-id="element-506">
              <div className="flex items-center gap-3" data-id="element-507">
                <Check className="w-5 h-5 text-[#14B8A6]" data-id="element-508" />
                <span className="text-lg text-[#3E2723] font-medium" data-id="element-509">
                  The Supermarket Sourcing Guide
                </span>
              </div>
              <span className="text-lg text-[#3E2723]/60 line-through" data-id="element-510">
                $29.00
              </span>
            </div>

            <div className="flex items-center justify-between py-3 border-b border-[#3E2723]/10" data-id="element-511">
              <div className="flex items-center gap-3" data-id="element-512">
                <Check className="w-5 h-5 text-[#14B8A6]" data-id="element-513" />
                <span className="text-lg text-[#3E2723] font-medium" data-id="element-514">
                  The "3-2-1" Resort Mixology Guide
                </span>
              </div>
              <span className="text-lg text-[#3E2723]/60 line-through" data-id="element-515">
                $19.00
              </span>
            </div>

            <div className="flex items-center justify-between py-3 border-b border-[#3E2723]/10" data-id="element-516">
              <div className="flex items-center gap-3" data-id="element-517">
                <Check className="w-5 h-5 text-[#14B8A6]" data-id="element-518" />
                <span className="text-lg text-[#3E2723] font-medium" data-id="element-519">
                  The Slow Cooker Pibil Hack
                </span>
              </div>
              <span className="text-lg text-[#3E2723]/60 line-through" data-id="element-520">
                $19.00
              </span>
            </div>

            <div className="flex items-center justify-between py-3 border-b border-[#3E2723]/10 bg-[#EC4899]/5 -mx-6 md:-mx-8 px-6 md:px-8" data-id="element-521">
              <div className="flex items-center gap-3" data-id="element-522">
                <Gift className="w-5 h-5 text-[#EC4899]" data-id="element-523" />
                <span className="text-lg text-[#3E2723] font-bold" data-id="element-524">
                  BONUS #1: 7-Day Mexican Meal Plan
                </span>
              </div>
              <span className="text-lg text-[#3E2723]/60 line-through" data-id="element-525">
                $13.00
              </span>
            </div>

            <div className="flex items-center justify-between py-3 border-b border-[#3E2723]/10 bg-[#EC4899]/5 -mx-6 md:-mx-8 px-6 md:px-8" data-id="element-526">
              <div className="flex items-start gap-3 pr-2" data-id="element-527">
                <Gift className="w-5 h-5 text-[#EC4899] flex-shrink-0 mt-1" data-id="element-528" />
                <div data-id="element-529">
                  <span className="text-lg text-[#3E2723] font-bold block" data-id="element-530">
                    BONUS #2: The Hidden 13th Recipe 🔒
                  </span>
                  <span className="text-xs text-[#3E2723]/60 italic" data-id="element-531">
                    Sealed inside the playbook — only revealed once you open
                    page 18.
                  </span>
                </div>
              </div>
              <span className="text-lg text-[#EC4899] font-bold whitespace-nowrap" data-id="element-532">
                FREE
              </span>
            </div>

            <div className="flex items-center justify-between py-3 bg-[#EC4899]/5 -mx-6 md:-mx-8 px-6 md:px-8 pb-4" data-id="element-533">
              <div className="flex items-start gap-3 pr-2" data-id="element-534">
                <Gift className="w-5 h-5 text-[#EC4899] flex-shrink-0 mt-1" data-id="element-535" />
                <div data-id="element-536">
                  <span className="text-lg text-[#3E2723] font-bold block" data-id="element-537">
                    BONUS #3: The Secret Resort Welcome Drink 🍹
                  </span>
                  <span className="text-xs text-[#3E2723]/60 italic" data-id="element-538">
                    The untold cocktail served only to VIP guests at Tulum's
                    most exclusive beach club — recipe inside.
                  </span>
                </div>
              </div>
              <span className="text-lg text-[#EC4899] font-bold whitespace-nowrap" data-id="element-539">
                FREE
              </span>
            </div>
          </div>

          <div className="bg-[#FBF7F0] p-6 md:p-8 border-t-2 border-dashed border-[#3E2723]/20" data-id="element-540">
            <div className="flex justify-between items-end mb-2" data-id="element-541">
              <span className="text-xl text-[#3E2723] font-medium" data-id="element-542">
                Total Value:
              </span>
              <span className="text-3xl text-[#3E2723]/50 line-through font-bold" data-id="element-543">
                $129.00
              </span>
            </div>
            <div className="flex justify-between items-end" data-id="element-544">
              <span className="text-2xl text-[#3E2723] font-bold" data-id="element-545">
                Today's Price:
              </span>
              <span className="text-5xl md:text-6xl text-[#C2410C] font-extrabold" data-id="element-546">
                $6.39
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}